import React, { useRef, useState } from 'react'
import Tooltip from '../../Tooltip/Tooltip'
import { TitleProps } from './Title.types'

const Title: React.FC<TitleProps> = ({
    buttons = null,
    tooltip,
    style = {},
    underlined = false,
    children,
    size = 'md',
    type,
}) => {
    const ref = useRef()
    const [isMouseOver, setIsMouseOver] = useState<boolean>(false)
    const classNames = () => {
        const c = ['r-title-container r-title']

        c.push('r-' + size)

        if (underlined) {
            c.push('r-style-underlined')
        }

        if (tooltip) {
            c.push('r-color-blue')
        }

        if (type === 'uppercase') {
            c.push('r-style-uppercase')
        }
        return c.join(' ')
    }

    return (
        <div style={style} data-testid='Title' className={classNames()}>
            <span
                className={'r-title'}
                ref={ref}
                onMouseEnter={() => setIsMouseOver(true)}
                onMouseLeave={() => setIsMouseOver(false)}
            >
                {children}
            </span>
            <div className={'r-title-buttons'}>{buttons}</div>
            {tooltip ? (
                <Tooltip anchor={ref} show={isMouseOver}>
                    {tooltip}
                </Tooltip>
            ) : (
                ''
            )}
        </div>
    )
}

export default Title
